import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponsePackage } from '../models/util.model';
import { MeterBrand } from '../models/meter-brand.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class MeterBrandService {
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'meter/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getAllForSelect(utilityId?: number) {
    return this.http.get<ResponsePackage<MeterBrand[]>>(
      `${this.pathApi}getAllMeterTypesForSelect${utilityId == null ? '' : '?utilityId=' + utilityId}`,
      { headers: this.headers, observe: 'response' }
    );
  }
}
